import React from 'react'
import './sass/style.css'
const loadingCard=()=> {
    return (
        <div class="loading-card">
        <div class="image"></div>
        <div class="content">
          <h2> </h2>
          <p></p>
          <p></p>
          <p></p>
        </div>
      </div>
    )
}

export default loadingCard
